import { render, staticRenderFns } from "./TaskHome.vue?vue&type=template&id=db2e02f6&scoped=true"
import script from "./TaskHome.vue?vue&type=script&lang=js"
export * from "./TaskHome.vue?vue&type=script&lang=js"
import style0 from "./TaskHome.vue?vue&type=style&index=0&id=db2e02f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2e02f6",
  null
  
)

export default component.exports